import dayjs from "dayjs";

export const useToastStore = defineStore("toast", {
  state: () => {
    return {
      message: "",
      timer: null,
      type: "success",

      // order received
      queue: [],
      orderMessage: "",
      orderTimer: null,
    };
  },

  actions: {
    show(data) {
      this.message = data.message;
      this.type = data.type || "success";

      if (this.timer) {
        clearTimeout(this.timer);
      }

      this.timer = setTimeout(() => {
        this.hide();
      }, data.timer || 10_000);

      // แตะตรงไหนก็ได้เพื่อปิด toast ไม่ต้องรอหมดเวลา
      // รอให้ click ที่เปิด toast (เช่นปุ่มจ่าย) จบก่อนค่อยผูก ไม่งั้นมันจะปิดตัวเองทันที
      // ใช้ capture เพื่อให้ปิดได้แม้ปุ่มใน modal จะ stopPropagation
      window.removeEventListener("click", this.hide, true);
      setTimeout(() => {
        if (this.message) window.addEventListener("click", this.hide, true);
      }, 0);
    },

    hide() {
      this.message = "";
      clearTimeout(this.timer);
      window.removeEventListener("click", this.hide, true);
    },

    // order received
    showOrder(job) {
      this.orderMessage = `Table ${job.table} :  received order at ${dayjs(
        job.timestamp
      ).format("HH:mm:ss")}`;

      if (this.orderTimer) {
        clearTimeout(this.orderTimer);
      }

      this.orderTimer = setTimeout(() => {
        this.orderMessage = "";
      }, 5_000);
    },
  },
});
